import React from 'react';
import ConsultaBoleto from './components/ConsultaBoleto';
import './App.css';

function App() {
  return (
    <div className="App">
      <ConsultaBoleto />
    </div>
  );
}

export default App;